import React, { useState, useEffect } from 'react';
import {
    Grid, Backdrop, Snackbar, CircularProgress, Typography, TextField, Button, Autocomplete,
    Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
// project imports
import SubCard from 'src/components/cards/SubCard';
import ThemeCustomization from 'src/themesNew';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import 'react-confirm-alert/src/react-confirm-alert.css';
import Alert from 'src/components/Alert';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import DesignServicesIcon from '@mui/icons-material/DesignServices';
import Page from 'src/components/Page';
import {
    Container,
    Card,
    CardHeader,
} from '@material-ui/core';
import {
    Select,
    MenuItem,
    Divider,
    CardContent,
} from '@material-ui/core';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';

// ==============================|| PROFILE 1 - PROFILE ACCOUNT ||============================== //

import { makeStyles } from '@material-ui/styles';
const useStyles = makeStyles((theme) => ({
    root: {
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3)
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}));

const LaborManagement = () => {

    const theme = useTheme();




    const classes = useStyles();


    const SessionUser = getUser();
    const [loading, setLoading] = useState(false);
    const [bolgeAdiKodu, setBolgeAdiKodu] = React.useState([]);
    const [selectedbolgeAdiKodu, setSelectedbolgeAdiKodu] = React.useState([]);
    const [EmployeeNr, setEmployeeNr] = useState(0);
    const [RoleTypes, setRoleTypes] = useState([]);
    const [NewRoleType, setNewRoleType] = useState('');
    const [loadingCombo, setLoadingCombo] = useState(false);
    const [UsersData, setUsersData] = useState([]);
    const [User, setUser] = useState([]);
    const [UserRolesData, setUserRolesData] = useState([]);
    const [uyari, setUyari] = useState(false);
    const [uyariTip, setUyariTip] = React.useState('default');
    const [responseMessage, setresponseMessage] = useState({
        ErrorCode: '0',
        ErrorDescription: 'success_message'
    });
    const [openNewDefectDialog, setOpenNewDefectDialog] = React.useState(false);
    const [userName, setUserName] = useState('');
    const [userCode, setUserCode] = useState('');
    const [userEmail, setUserEmail] = useState('');
    const [userTopServiceShopCode, setUserTopServiceShopCode] = useState({});
    const [userBusinessType, setUserBusinessType] = useState(-1);

    const [TypeDsc, setTypeDsc] = useState('');

    useEffect(() => {

    }, []);

    const handleOpenNewDefectDialog = () => {
        setOpenNewDefectDialog(true);
    };

    const handleCloseOpenNewDefectDialog = () => {
        setOpenNewDefectDialog(false);
    };

    const uyariKapat = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setUyari(false);
    };

    return (
        <Page className={classes.root}>
            <ThemeCustomization>
                {
                    loading ?
                        <Backdrop className={classes.backdrop} open={loading}>
                            <CircularProgress color="inherit" />
                        </Backdrop>
                        : <div></div>
                }
                <Snackbar
                    open={uyari}
                    autoHideDuration={10000}
                    onClose={uyariKapat}
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                >
                    <Alert onClose={uyariKapat} variant={uyariTip} message={responseMessage}
                    ></Alert>
                </Snackbar>
                <Container maxWidth="xl">
                    <Card>
                        <CardHeader title={<Typography variant="h4">Hizmet Kodları Kılavuzu</Typography>} />
                        <Divider />
                        <CardContent>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12} md={12}>
                                    <SubCard title="İşlem" style={{ minHeight: 200 }}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={12} md={4}>
                                                <Autocomplete
                                                    options={UsersData}
                                                    value={User}
                                                    noOptionsText="Model bulunamadı"
                                                    getOptionLabel={(i) => i?.Dsc || ""}
                                                    //onChange={(event, val) => setUserParam(val)}
                                                    //   onInputChange={(event, newInputValue) => {
                                                    //     handleUsers(newInputValue);
                                                    //   }}
                                                    fullWidth
                                                    renderInput={(params) => <TextField {...params} label="Model"
                                                        InputProps={{
                                                            ...params.InputProps,
                                                            endAdornment: (
                                                                <>
                                                                    {loadingCombo && <CircularProgress color="primary" size={20} />}
                                                                    {params.InputProps.endAdornment}
                                                                </>
                                                            ),
                                                        }}
                                                    />}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={8} >
                                                <Stack direction="row" spacing={1} justifyContent={"flex-end"}>
                                                    <Button
                                                        variant="contained"
                                                        color="secondary"
                                                        style={{ textTransform: 'none' }}
                                                        startIcon={<DesignServicesIcon />}
                                                        onClick={handleOpenNewDefectDialog}
                                                    >
                                                        Hizmet Ekle
                                                    </Button>

                                                    <Button
                                                        variant="contained"
                                                        color="secondary"
                                                        style={{ textTransform: 'none' }}
                                                        startIcon={<MenuBookIcon />}
                                                        onClick={handleOpenNewDefectDialog}
                                                    >
                                                        Hizmet Kılavuzu
                                                    </Button>
                                                </Stack>
                                            </Grid>
                                        </Grid>
                                    </SubCard>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12}>
                                    <SubCard title="Yetki Bilgileri" style={{ minHeight: 400 }}>

                                    </SubCard>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Container>
                <Dialog open={openNewDefectDialog} onClose={handleCloseOpenNewDefectDialog} aria-labelledby="form-dialog-title">
                    {openNewDefectDialog && (
                        <>
                            <DialogTitle id="form-dialog-title">Yeni Kullanıcı Oluştur</DialogTitle>
                            <DialogContent>
                                <Stack spacing={3}>
                                    <DialogContentText>
                                        <Typography variant="body2" component="span">
                                            Eğer bir kullanıcıyı aradığınızda bulamadıysanız, yeni bir kullanıcı oluşturabilirsiniz.
                                        </Typography>
                                    </DialogContentText>
                                    <TextField
                                        autoFocus
                                        value={userCode}
                                        onChange={(e) => setUserCode(e.target.value)}
                                        label="Model Grubu"
                                        type="text"
                                        fullWidth />
                                    <TextField
                                        value={userName}
                                        onChange={(e) => setUserName(e.target.value)}
                                        label="SKU"
                                        type="text"
                                        fullWidth />
                                        <TextField
                                        value={userEmail}
                                        onChange={(e) => setUserEmail(e.target.value)}
                                        label="Hizmet Kodu"
                                        type="text"
                                        fullWidth /><TextField
                                        value={userEmail}
                                        onChange={(e) => setUserEmail(e.target.value)}
                                        label="Hizmet Tipi"
                                        type="text"
                                        fullWidth />
                                    <TextField
                                        value={userEmail}
                                        onChange={(e) => setUserEmail(e.target.value)}
                                        label="Hizmet Açıklama"
                                        type="text"
                                        fullWidth />
                                        
                                    <Autocomplete
                                        autoFocus
                                        value={userTopServiceShopCode}
                                        options={bolgeAdiKodu}
                                        getOptionLabel={option => (option.Dsc ? option.BirimKodu + ' - ' + option.Dsc : '')}
                                        onChange={(event, newValue) => {
                                            setUserTopServiceShopCode(newValue);
                                        }}
                                        renderInput={(params) => <TextField {...params} label="Sınıflandırma" variant="outlined" />}

                                    />
                                    <Select
                                        label="Yetki Tipi"
                                        variant='outlined'
                                        value={userBusinessType}
                                        onChange={(e) => setUserBusinessType(e.target.value)}
                                        fullWidth
                                        size="small"

                                    >
                                        <MenuItem value={0}>Bölge</MenuItem>
                                        <MenuItem value={2}>Müşteri Hizmetleri</MenuItem>
                                        <MenuItem value={1}>Diğer</MenuItem>
                                    </Select>
                                </Stack>
                            </DialogContent>
                            <DialogActions sx={{ pr: 2.5 }}>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    style={{ textTransform: 'none' }}
                                    onClick={handleCloseOpenNewDefectDialog}
                                >
                                    İptal
                                </Button>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    style={{ textTransform: 'none' }}
                                //onClick={handleAddNewApplicationUser}
                                >
                                    Oluştur
                                </Button>
                            </DialogActions>
                        </>
                    )}
                </Dialog>
            </ThemeCustomization>
        </Page>
    );
};

export default LaborManagement;
